#import "./UsDueDiligenceFields.graphql"

query GetUsDueDiligence($id: ID!) {
  usDueDiligence(id: $id) {
    ...UsDueDiligenceFields
  }
}
